/** First-run popup state. Stored on the existing user profile, not a new collection. */

export const ONBOARDING_DRAFT_KEY = "endurava.onboarding.draft";

export function onboardingDraftKey(userId) {
  if (!userId) return null;
  return `${ONBOARDING_DRAFT_KEY}.${userId}`;
}

const IDENTITY_FIELDS = [
  "default_sport",
  "dob",
  "height_cm",
  "weight_kg",
  "gender",
  "experience_level",
];

export function profileIdentityComplete(user) {
  if (!user) return false;
  return IDENTITY_FIELDS.every((field) => user[field] !== null && user[field] !== undefined && user[field] !== "");
}

/** Established means imported activities, Strava, or a current training plan. */
export function onboardingAutoOpen(user, signals = {}) {
  if (!user) return false;
  if (user.onboarding_status === "complete" || user.onboarding_status === "dismissed") return false;
  if (profileIdentityComplete(user) && !readOnboardingDraft(user.user_id)) return false;
  if (readOnboardingDraft(user.user_id)) return true;
  if (user.strava_connected || signals.activities === "some" || signals.plan === "yes") return false;
  if (signals.activities !== "none" || signals.plan !== "no") return false;
  return true;
}

export function canResumeOnboarding(user) {
  if (!user || user.onboarding_status === "complete") return false;
  if (user.onboarding_status === "dismissed") return true;
  return !profileIdentityComplete(user);
}

export function showOnboardingResume(user, signals = {}, open = false) {
  if (open || !canResumeOnboarding(user)) return false;
  if (user.onboarding_status === "dismissed") return true;
  if (readOnboardingDraft(user.user_id)) return false;
  if (user.strava_connected || signals.activities === "some" || signals.plan === "yes") return true;
  return signals.activities === "none" && signals.plan === "no" && !onboardingAutoOpen(user, signals);
}

export function readOnboardingDraft(userId) {
  const key = onboardingDraftKey(userId);
  if (!key) return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeOnboardingDraft(userId, form) {
  const key = onboardingDraftKey(userId);
  if (!key) return;
  sessionStorage.setItem(key, JSON.stringify(form));
}

export function clearOnboardingDraft(userId) {
  const key = onboardingDraftKey(userId);
  if (key) sessionStorage.removeItem(key);
  sessionStorage.removeItem(ONBOARDING_DRAFT_KEY);
}
